(function autoCloseDetails() {
  const initializeExclusiveGroups = (scope = document) => {
    scope.querySelectorAll('[data-sh-exclusive-accordion]').forEach((group) => {
      const openedItems = [...group.querySelectorAll('details[open]')].filter(
        (item) => item.closest('[data-sh-exclusive-accordion]') === group
      );

      openedItems.slice(1).forEach((item) => item.removeAttribute('open'));
    });
  };

  initializeExclusiveGroups();

  document.addEventListener('shopify:section:load', (event) => initializeExclusiveGroups(event.target));

  document.addEventListener(
    'toggle',
    function (event) {
      const openedItem = event.target;
      if (!(openedItem instanceof HTMLDetailsElement) || !openedItem.open) return;

      const group = openedItem.closest('[data-sh-exclusive-accordion]');
      if (!group) return;

      [...group.querySelectorAll('details[open]')]
        .filter(
          (item) => item !== openedItem && item.closest('[data-sh-exclusive-accordion]') === group
        )
        .forEach((item) => item.removeAttribute('open'));
    },
    true
  );

  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
